import React, { useState } from 'react';
import { TestimonialLayout } from './testimonials/TestimonialLayout';
import { TestimonialHeader } from './testimonials/TestimonialHeader';
import { TestimonialMetric } from './testimonials/TestimonialMetric';
import { TestimonialQuote } from './testimonials/TestimonialQuote';
import { Activity, Brain, Heart } from 'lucide-react';
import { VideoModal } from '../common/VideoModal';
import { IMAGE_PATHS } from '@/utils/images';

const metrics = [
  {
    icon: Activity,
    label: "Fitness Goals",
    value: "85%",
    detail: "17 of 20 milestones reached",
    color: "text-neon-green"
  },
  {
    icon: Brain,
    label: "Career Growth",
    value: "75%",
    detail: "15 of 20 milestones reached",
    color: "text-neon-purple"
  },
  {
    icon: Heart,
    label: "Work-Life Balance",
    value: "80%",
    detail: "16 of 20 milestones reached",
    color: "text-yellow-400"
  }
];

export const JasonTestimonial: React.FC = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <TestimonialLayout>
      <div className="relative">
        {/* Hero Image with Error Handling */}
        <div className="relative h-[80vh] overflow-hidden">
          <div className="absolute inset-0">
            <img 
              src={IMAGE_PATHS.JASON_AVATAR}
              alt="Jason"
              className="w-full h-full object-cover object-top"
              onError={(e) => {
                const img = e.target as HTMLImageElement;
                img.onerror = null;
                img.src = IMAGE_PATHS.FALLBACK;
              }}
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black" />
        </div>

        {/* Content overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-12">
          <div className="max-w-7xl mx-auto">
            <div className="space-y-6 max-w-2xl">
              <TestimonialHeader 
                title="Meet Jason: A LifeTrack Success Story 🚀"
                subtitle="At 35, Jason has mastered the balance between career success and personal wellbeing with LifeTrack."
              />

              <div className="grid grid-cols-3 gap-4">
                {metrics.map((metric) => (
                  <TestimonialMetric key={metric.label} {...metric} />
                ))}
              </div>

              <TestimonialQuote 
                quote="LifeTrack helped me transform my approach to work-life balance. I'm now more productive at work while maintaining a healthy lifestyle and spending quality time with my family."
                author="Jason"
              />
            </div>
          </div>
        </div>
      </div>

      <VideoModal
        isOpen={showVideo}
        onClose={() => setShowVideo(false)}
        videoUrl={IMAGE_PATHS.DEFAULT_VIDEO}
      />
    </TestimonialLayout>
  );
};